import { styled } from '@root/stitches.config';

export const BarChartWrapper = styled('div', {
  background: '$white',
  padding: '$16',
  br: 18,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column'
});